import { Map, View } from 'ol';
import MVT from 'ol/format/MVT';
import { fromLonLat } from 'ol/proj';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import { Point2 } from '../models/point.type';

export class MapService {

    private map?: Map;

    async loadFeaturesOfMapExtent(url: string, zoom: number, mapCenterLon: number, mapCenterLat: number): Promise<{ map: Map, features: any }> {
        return new Promise((resolve, reject) => {
            const vtLayer = new VectorTileLayer({
                source: new VectorTileSource({
                    format: new MVT(),
                    url,
                    cacheSize: 512
                }),
            });

            if (!this.map) {
                this.map = new Map({
                    layers: [vtLayer],
                    target: 'map',
                    view: new View({
                        center: fromLonLat([mapCenterLon, mapCenterLat]),
                        zoom: zoom + 1,
                        constrainResolution: true,
                        maxZoom: zoom + 1,
                        minZoom: zoom + 1,
                    }),
                });
            } else {
                this.map.dispose();
                this.map = new Map({
                    layers: [vtLayer],
                    target: 'map',
                    view: new View({
                        center: fromLonLat([mapCenterLon, mapCenterLat]),
                        zoom: zoom + 1,
                        constrainResolution: true,
                        maxZoom: zoom + 1,
                        minZoom: zoom + 1,
                    }),
                });
            }

            this.map.once('rendercomplete', () => {
                if(this.map){
                    const extent = this.map.getView().calculateExtent();
                    return resolve({ map: this.map, features: vtLayer.getSource().getFeaturesInExtent(extent) });
                }
            });

            this.map.once('error', (err) => {
                reject(err);
            })
        })

    }

    compensateAndScaleCoordinates(coord: number[][], compensationCoord: number[], scale: number){
        return coord.map(x => x.map((x, index) => this.compensateAndScaleCoord(x, compensationCoord[index], scale)))
    }

    sortFlatCoordinatesToArrays(coord: Point2, compensationCoord: Point2, scale: number){
        const xs = coord.filter((_, i) => (i + 1) % 2 !== 0).map(x => this.compensateAndScaleCoord(x, compensationCoord[0], scale));
        const ys = coord.filter((_, i) => (i + 1) % 2 === 0).map(y => this.compensateAndScaleCoord(y, compensationCoord[1], scale));
        return xs.map((x, i) => ([x, ys[i]]));
    }

    compensateAndScaleCoord(c: number, compensationCoord: number, scale: number){
        return  (c - compensationCoord) * scale;
    }
}